import BeveledBoxSvg94x89 from './BeveledBoxSvg94x89';

export default BeveledBoxSvg94x89;
export { BeveledBoxSvg94x89 };
